


 <div class="container-xxl flex-grow-1 container-p-y">
              <div class="row">
                <div class="col-lg-12 mb-4 order-0">
                  <div class="card">
                        <div class="card-body">
                            <div>
                                <h3>ダッシュボード</h3>
                            </div>
                        </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4 order-0">

                    <div class="card">
                        <div class="card-header">
                          <h4>レントゲン統計</h4>
                        </div>
                        <div class="card-body" style="height: 300px;">
                          <div class="row text-center">
                            <div class="col">
                              <h3>{{totalCount}}</h3>
                              <p>総レントゲン数</p>
                            </div>
                            <div class="col">
                              <h3>{{validCount}}</h3>
                              <p>有効</p>
                            </div>
                            <div class="col">
                              <h3>{{invalidCount}}</h3>
                              <p>無効</p>
                            </div> 
                             <div class="col">
                              <h3></h3>
                              <p></p>
                            </div>                            
                           
                          </div>
                        </div>
                      </div>
                </div>
              </div>
 </div>
